<!-- start app-sign-up -->
<div class="sign_in def_p bluer_section">
    <div class="custom_container position-relative">
        <div class="wrap_container" *ngIf="(route.data | async)?.listToggleBar || (route.data | async)?.listToggleBar == undefined">
            <!-- import app-tabs -->
            <app-tabs [tabs]="userTypeTabs"></app-tabs>
        </div>
    
        <div class="wrap_navigate overflow-hidden">
            <!-- import app-navigation -->
            <app-navigation [navigate]="(route.data | async)?.navigation"></app-navigation>
        </div>
    
        <div class="wrap_container">
            <form [formGroup]="FormSingIn" (ngSubmit)="singIn()">
                <ng-container *ngFor="let Input of listInput">
                    <!-- import app-label -->
                    <app-label 
                        [for]="Input.name"
                        [title]="Input.title" 
                        [style]="{color: '#fff'}"
                    >
                    </app-label>
        
                    <!-- import app-input-phone  -->
                    <app-input-phone 
                        *ngIf="Input.name == 'phone'"
                        [type]="Input.type" 
                        [name]="Input.name" 
                        [FormParent]="FormSingIn"
                        (formateNumber)="getCode_hasSelected($event)"
                    >
                    </app-input-phone>

                    <!-- import app-input-text  -->
                    <app-input-text 
                        *ngIf="Input.name != 'phone'"
                        [type]="Input.type" 
                        [name]="Input.name"
                        [FormParent]="FormSingIn"
                        [placeholder]="Input.placeholder"
                        [validations]="Input.validators || []"
                    >
                    </app-input-text>
        
                </ng-container>
                <a routerLink="/forget-password" class="label_lg_normal d-block text-end forget">نسيت كلمة المرور ؟</a>

                <!-- // show if server backend responded by errors -->
                <ng-container *ngIf="errorsMsg.length > 0">
                    <div class="wrap_error_server text-center">
                        <div class="wrap d-inline-block">
                            <ng-container *ngFor="let err of errorsMsg">
                                <!-- import app-validation-input  -->
                                <app-validation-input 
                                    [text]="err.msg"
                                    [style]="{'margin-inline-start': '0px', margin: 0}" 
                                >
                                </app-validation-input>
                            </ng-container>
                        </div>
                    </div>
                </ng-container>
                
                <div class="wrap_btn text-center">
                    <!-- import app-btn -->
                    <app-btn 
                        [submit]="true"
                        title="تسجيل دخول" 
                        [disabled]="FormSingIn.invalid || isLoading" 
                    >
                    </app-btn>

                    <a 
                        [routerLink]="[routeData?.USERS_TYPES?.includes(type.normalUser) ? '/sign-up-user' : '/sign-up-office']" 
                        class="label_lg_normal d-block"
                    >
                        إنشاء حساب
                    </a>
                </div>
            </form>
        </div>
    </div>
</div>
<!-- end app-sign-up -->